export default __webpack_public_path__ + "static/media/DOMINIC.83400596.png";